



































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Quotes, { Quote, QuoteTerm } from '@/services/Quotes';
import { quoteProviderProcedures } from './QuoteFilters';

@Component
export default class QuoteSummaryTable extends Vue {
     @Prop(Quote) private quote: Quote;

     get quoteRateTerms(): QuoteTerm[] {
          return Quote.getRate(this.quote).terms;
     }

     private getProviderProcedures(profileIndex) {
          return quoteProviderProcedures(this.quote, profileIndex);
     }
}
